export { default as ProductIdentifier } from './product-identifier'
